import lodash from "lodash";

const MANDATORY_KEYS = [
  "websiteRoot",
  "prefixUrl",
  "CAPTCHA_PUBLIC",
  "GOOGLE_MAP_KEY",
  "api.baseUrl",
  "api.tPanelUrl",
  "tnAccountDomain",
  "yettelAppUrl",
  "ysdUrl",
  "yPayUrl",
  "cartOverviewNewUrl",
  "businessPortalUrl",
  "offersOnInstallmentsCampaignPageUrlSr",
  "offersOnInstallmentsCampaignPageUrlEn",
  "isManhattanVisible",
  "walletHomepage",
  "smarticTpId",
  "recentlyViewedProductsLimit",
  "hipernetUrl"
];

// Prepare webview data
export const isWebView = () : boolean => {
  return process.env.REACT_APP_WEBVIEW === "true";
};

const Config = {
  CAPTCHA_PUBLIC: process.env.REACT_APP_CAPTCHA_PUBLIC ?? "",
  GOOGLE_MAP_KEY: process.env.REACT_APP_GOOGLE_MAP_KEY ?? "",
  PUBLIC_URL: process.env.PUBLIC_URL,
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL ?? "",
    tPanelUrl: process.env.REACT_APP_TPANEL_URL ?? ""
  },
  websiteRoot: process.env.REACT_APP_WEBSITE_ROOT ?? "",
  websitePrefix: process.env.REACT_APP_URL_SITE_PREFIX ?? "",
  webshopUrl: process.env.REACT_APP_WEBSHOP_ROOT ?? "https://www.yettel.rs/webshop",
  imagePath: process.env.REACT_APP_IMAGE_PATH ?? "",
  prefixUrl: process.env.REACT_APP_URL_PREFIX ?? "",
  domain: process.env.REACT_APP_DOMAIN ?? "",
  yettelAppUrl: process.env.REACT_APP_MOJ_YETTEL_URL ?? "https://www.yettel.rs/yettel/",
  ysdUrl: process.env.REACT_APP_YSD_URL ?? "https://shopping.yettel.rs/",
  yPayUrl: process.env.REACT_APP_YPAY_URL ?? "https://www.yettel.rs/placanja",
  hipernetUrl: process.env.REACT_APP_HIPERNET_URL ?? "https://ytl.rs/hnapp",
  walletHomepage: process.env.REACT_APP_WALLET_HOMEPAGE ?? "",
  cartOverviewNewUrl: process.env.REACT_APP_CART_OVERVIEW_NEW_URL ?? "https://www.yettel.rs/staging/webshop/sr/Privatni-korisnici/Kupovina",
  businessPortalUrl: process.env.REACT_APP_BUSINESS_PORTAL_URL ?? "https://www.yettel.rs/biznisportal/",
  offersOnInstallmentsCampaignPageUrlSr: process.env.REACT_APP_OFFERS_ON_INSTALLMENTS_CAMPAIGN_PAGE_URL_SR ?? "",
  offersOnInstallmentsCampaignPageUrlEn: process.env.REACT_APP_OFFERS_ON_INSTALLMENTS_CAMPAIGN_PAGE_URL_EN ?? "",
  businessOffersOnInstallmentsCampaignPageUrlSr: process.env.REACT_APP_BUSINESS_OFFERS_ON_INSTALLMENTS_CAMPAIGN_PAGE_URL_SR ?? "",
  businessOffersOnInstallmentsCampaignPageUrlEn: process.env.REACT_APP_BUSINESS_OFFERS_ON_INSTALLMENTS_CAMPAIGN_PAGE_URL_EN ?? "",
  ebillDetailsUrl: process.env.REACT_APP_EBILL_DETAILS_URL ?? "https://www.yettel.rs/sr/privatni/usluge/ostale-usluge/racuni-i-ugovori/e-racun",
  recycleDetailsUrl: process.env.REACT_APP_RECYCLE_DETAILS_URL ?? "https://www.yettel.rs/sr/privatni/ponuda/aktuelno/reciklaza-uredjaja",
  telcoTariffPackagesPageSr: process.env.REACT_APP_TELCO_TARIFF_PACKAGE_SR ?? "",
  telcoTariffPackagesPageEn: process.env.REACT_APP_TELCO_TARIFF_PACKAGE_EN ?? "",
  isManhattanVisible: process.env.REACT_APP_MANHATTAN_VISIBILITY === "true" || false,
  isTvVisible: process.env.REACT_APP_TV_VISIBILITY === "true" || false,
  isCordlessPhoneVisible: process.env.REACT_APP_CORDLESS_PHONE_VISIBILITY === "true" || false,
  ftthSr: process.env.REACT_APP_FTTH_SR ?? "",
  ftthEn: process.env.REACT_APP_FTTH_EN ?? "",
  ftthTariffPackagesSr: process.env.REACT_APP_FTTH_TARIFF_PACKAGES_SR ?? "",
  ftthTariffPackagesEn: process.env.REACT_APP_FTTH_TARIFF_PACKAGES_EN ?? "",
  ottTariffPackagesSr: process.env.REACT_APP_OTT_TARIFF_PACKAGE_SR ?? "",
  ottTariffPackagesEn: process.env.REACT_APP_OTT_TARIFF_PACKAGE_EN ?? "",
  ottGeneralConditions: process.env.REACT_APP_OTT_GENERAL_CONDITIONS ?? "",
  ottSpecialConditions: process.env.REACT_APP_OTT_SPECIAL_CONDITIONS ?? "",
  ottPrivacyPolicy: process.env.REACT_APP_OTT_PRIVACY_POLICY ?? "",
  ottWebshopPurchaseTerms: process.env.REACT_APP_OTT_WEBSHOP_PURCHASE_TERMS ?? "",
  ottYettelPayService: process.env.REACT_APP_OTT_YETTEL_PAY_SERVICE ?? "",
  postpaidOttTariffPackagesSr: process.env.REACT_APP_POST_OTT_TARIFF_PACKAGE_SR ?? "",
  postpaidOttTariffPackagesEn: process.env.REACT_APP_POST_OTT_TARIFF_PACKAGE_EN ?? "",
  smarticTpId: 302,
  recentlyViewedProductsLimit: process.env.REACT_APP_RECENTLY_VIEWED_PRODUCTS_LIMIT ?? 10,
  tnAccountDomain: process.env.REACT_APP_TNACCOUNT_DOMAIN ?? 'https://www.yettel.rs/nalog',
  tnAccountClientId: process.env.REACT_APP_TNACCOUNT_CLIENT_ID ?? '',
  tnAccountClientSecret: process.env.REACT_APP_TNACCOUNT_CLIENT_SECRET ?? '',
  deviceInsuranceUrl: {
    sr: process.env.REACT_APP_DEVICE_INSURANCE_SR ?? '',
    en: process.env.REACT_APP_DEVICE_INSURANCE_EN ?? '',
  },
  deviceInsuranceAdditionalConditions: {
    sr: process.env.REACT_APP_DEVICE_INSURANCE_ADDITIONAL_CONDITIONS_SR ?? '',
    en: process.env.REACT_APP_DEVICE_INSURANCE_ADDITIONAL_CONDITIONS_EN ?? ''
  },
  deviceInsurancePreContractualNotice: {
    sr: process.env.REACT_APP_DEVICE_INSURANCE_PRE_CONTRACTUAL_NOTICE_SR ?? '',
    en: process.env.REACT_APP_DEVICE_INSURANCE_PRE_CONTRACTUAL_NOTICE_EN ?? ''
  },
  generalInfoLink: process.env.REACT_APP_GENERAL_INFO ?? '',
  withIDP: process.env.REACT_APP_WITH_IDP === "true" || false,
  withFNP: process.env.REACT_APP_WITH_FNP === "true" || false,
  isChristmasMaintenance: process.env.REACT_APP_MAINTENANCE_CHRISTMAS === "true" || false,
  isSSOTestFormVisible: process.env.REACT_APP_SSO_TEST_FORM_VISIBLE === "true" || false,
  oldPriceLimit: Number(process.env.REACT_APP_OLD_PRICE_LIMIT) || 0,
  isSubsidyOff: process.env.REACT_APP_SUBSIDY_OFF === "true" || false,
  webshopPurchaseInfo: process.env.REACT_APP_WEBSHOP_PURCHASE_INFO ?? '',
  recommendedTvModels: process.env.REACT_APP_RECOMMENDED_TV_MODELS ?? '',
  isAccessoryVisible: process.env.REACT_APP_ACCESSORY_VISIBILITY === "true" || false,
  isEsimCmAllowed: process.env.REACT_APP_ESIM_CM === "true" || false
} as const;

type ConfigKeys = keyof typeof Config;
export type ConfigType = typeof Config[ConfigKeys];

// Validate that ENV is correct

const missingKeys = lodash.reduce(MANDATORY_KEYS, (missing: string[], key): string[] => {
  const value = lodash.get(Config, key);
  if (value === undefined || value === null) {
    missing.push(key);
  }
  return missing;
}, []);

if (missingKeys.length) {
  throw new Error(`The following values are missing from your env: ${missingKeys.join(", ")}`);
}

export default Config;
